// extracted by mini-css-extract-plugin
module.exports = {"productDetails":"Dp3Gm","productDetailsHideOnHover":"qICCE MISxK","leftText":"SCvC-","centerText":"QoISl","rightText":"Z6lV7"};